import { render, staticRenderFns } from "./ItemSummary.vue?vue&type=template&id=e2e13d56&scoped=true&"
import script from "./ItemSummary.vue?vue&type=script&lang=js&"
export * from "./ItemSummary.vue?vue&type=script&lang=js&"
import style0 from "./ItemSummary.vue?vue&type=style&index=0&id=e2e13d56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e13d56",
  null
  
)

export default component.exports